import React from 'react';
const CART_LINK = '[CART_LINK]';
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
}
export function CTAButton({
  children,
  className = ''
}: CTAButtonProps) {
  return <a href={CART_LINK} className={`inline-flex w-full items-center justify-center rounded-2xl bg-rose-600 px-6 py-4 text-center text-base font-bold text-white shadow-lg shadow-rose-200 transition hover:bg-rose-700 md:w-auto ${className}`} data-id="element-1">
      {children}
    </a>;
}